import { render, staticRenderFns } from "./selectPosition.vue?vue&type=template&id=3bb2eda5&"
import script from "./selectPosition.vue?vue&type=script&lang=js&"
export * from "./selectPosition.vue?vue&type=script&lang=js&"
import style0 from "./selectPosition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb2eda5')) {
      api.createRecord('3bb2eda5', component.options)
    } else {
      api.reload('3bb2eda5', component.options)
    }
    module.hot.accept("./selectPosition.vue?vue&type=template&id=3bb2eda5&", function () {
      api.rerender('3bb2eda5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/WuyeZiyuanManager/building/selectPosition.vue"
export default component.exports